export default __webpack_public_path__ + "static/media/package-4.00116575.png";